// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1KTsm","bigColWidth":"Table_bigColWidth__1YCuP","biggerColWidth":"Table_biggerColWidth__3JR_H","row":"Table_row__2PYpq","col":"Table_col__2MBqq"};